import { combineReducers } from 'redux'

import languageReducer from './LanguageReducer'
import preCheckoutReducer from './PreCheckoutReducer'
import reservationReducer from './ReservationReducer'
import serviceNotificationsReducer from './serviceNotificationsSlice'
import validationReducer from './ValidationReducer'

const rootReducer = combineReducers({
  reservationReducer,
  languageReducer,
  validationReducer,
  preCheckoutReducer,
  serviceNotifications: serviceNotificationsReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
